module.exports = __webpack_public_path__ + "assets/img/lookatwap.bf935644.png";